import type { VacationOverviewPeriod } from '../../models/vacationOverview.types';

export type PeriodPhase = 'past' | 'current' | 'future';

export function periodPhase(period: VacationOverviewPeriod, todayIso: string): PeriodPhase {
	if (period.endDate < todayIso) return 'past';
	if (period.startDate <= todayIso && todayIso <= period.endDate) return 'current';
	return 'future';
}
